import { useEffect, useState } from 'react';
import LoanInfoService from '../../../service/LoanInfo';
import { s } from './CourtInformation.styles';
import { DetailNoDataColumn } from '../../components/nodata/NoData'
import Loading from '../../../func/components/loading/LoadingCircle';
import styled from 'styled-components';
import { BasicInfo } from './data';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/footer/Footer';
const exportIcon = '/assets/images/icon/Icon_Export_gray.svg'
const arrowIcon = '/assets/images/icon/Arrow.svg'
const DateDetails = () => {
  const [basicInfo, setBasicInfo] = useState<BasicInfo>();
  const [data, setData] = useState<string[][]>([]);
  const [loading, setLoading] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const iidx = params.get('iidx');
  const navigate = useNavigate();
  const getData = async (iidx: number) => {
    try {
      setLoading(true);
      const res = await LoanInfoService.courtDetail(iidx);
      setData(res.data.date_list || []);
      setBasicInfo(res.data.case_detail.basic_info); 
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (iidx) {
      getData(Number(iidx));
    }
  }, []);

  useEffect(() => {
  window.scrollTo(0, 0);
  }, [iidx]);

  
  return (
    <s.Container>
      {loading && <Loading />}
      {!loading && (
        <s.Inner>
          <TitleWrapper>
            <PageTitleBox>
              <div style={{display:'flex', alignItems: 'center', gap:'6px', letterSpacing:'-0.36px'}}>
                <BackButton onClick={() => window.close()}>
                  <img src={arrowIcon} alt="" />
                </BackButton>
                <div style={{ color: '#222222' }} >{basicInfo?.case_no} 기일내역</div>
              </div>
              <IconWrapper>
                <img src={exportIcon} alt="" style={{ width: '24px', height: '24px' }}/>
              </IconWrapper>
              </PageTitleBox>
          </TitleWrapper>
          <s.Content style={{ padding: '16px 16px 0' }}>
            <s.ContentTitleBox style={{ padding:'16px 0 24px' }}>기일내역</s.ContentTitleBox>
            <TableScrollWrapper style={{ width: '100%' }}>
            <s.Table style={{ minWidth: '695px', width: 'fit-content' }}>
              <thead>
                <s.Row style={{ height: '39px'}}>
                  <s.TableHeadTh width="160px">물건번호 / 감정평가액</s.TableHeadTh>
                  <s.TableHeadTh width="140px">기일 / 기일종류</s.TableHeadTh>
                  <s.TableHeadTh width="140px">최저매각가격</s.TableHeadTh>
                  <s.TableHeadTh width="170px">기일장소</s.TableHeadTh>
                  <s.TableHeadTh width="90px">기일결과</s.TableHeadTh>
                </s.Row>
              </thead>
              <tbody>
                {data.length > 0 &&
                  data.map((item, index) => (
                    <s.Row key={index}>
                      {index === 0 && (
                        <>
                          <s.ContentCell
                            width="160px"
                            border={true}
                            textAlign="center"
                            rowSpan={data.length}
                            style={{ borderRight: '1px solid #e1e2e4' }}
                          >
                          1 / {item[1]}
                          </s.ContentCell>
                        </>
                      )}
                      <s.ContentCell
                        width="140px"
                        border={true}
                        textAlign="left"
                        style={{ borderRight: '1px solid #e1e2e4' }}
                      >
                        <div style={{ color: '#616161' }}>{item[2]}</div>{item[3]}
                      </s.ContentCell>
                      <s.ContentCell
                        width="170px"
                        border={true}
                        textAlign="center"
                        style={{ borderRight: '1px solid #e1e2e4' }}
                      >
                        {item[5]}
                      </s.ContentCell>
                      <s.ContentCell
                        width="140px"
                        border={true}
                        textAlign="center"
                        style={{ borderRight: '1px solid #e1e2e4' }}
                      >
                        {item[4]}
                      </s.ContentCell>
                      <s.ContentCell
                        width="90px"
                        border={true}
                        textAlign="center"
                      >
                        {item[6]}
                      </s.ContentCell>
                    </s.Row>
                  ))}
                {data.length === 0 && <DetailNoDataColumn absorption={7} />}
              </tbody>
              </s.Table>
            </TableScrollWrapper>
          </s.Content>
        </s.Inner>
      )}
       <Footer/>
    </s.Container>
  );
};
export default DateDetails;

const TitleWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #70737C29;
`

const PageTitleBox = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
  ;
`

const BackButton = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const IconWrapper  = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const TableScrollWrapper = styled.div`
  overflow-x: auto;
  padding-bottom: 24px; 
  width: 100%;
  margin-bottom: 40px;

  &::-webkit-scrollbar {
    height: 8px;
    background-color: #000;
  }

  &::-webkit-scrollbar-track {
     
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #999;
  }

  &::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
  }
  scrollbar-color: #C1C1C1 #F0F0F0; /* Firefox */
  scrollbar-width: thin;
`;